export const enum ProcessMapNodeCategories {
  Default = 1,
  CustomEmail = 2,
  DecisionGateway = 3
}
